import { ExtensionApiFactory } from '~cdw-ae/common/frontend/browser-extension-api';

import { OFFLINE_SYNC_FIELDS, OfflineSyncFields } from './offline-sync.interfaces';

import { RootState, rootStore } from '../extension-store/extension.store';
import { clearOfflineSessionPings } from '../update-session/update-session.state';
import UtilsService from '../utils/utils.service';

/**
 * Move the offline session pings to local storage.
 * @param currentOfflineFields - The current offline sync fields.
 * @param appState - The application state.
 * @returns The updated offline sync fields.
 */
const updateOfflineSessionPings = async (
  mutableCurrentOfflineFields: OfflineSyncFields,
  appState: RootState
): Promise<void> => {
  const extensionApi = ExtensionApiFactory();
  if (
    Array.isArray(appState.updateSessionState.offlineSessionPings) &&
    appState.updateSessionState.offlineSessionPings.length > 0
  ) {
    if (!Array.isArray(mutableCurrentOfflineFields.offlineSessionPings)) {
      mutableCurrentOfflineFields.offlineSessionPings = [];
    }

    mutableCurrentOfflineFields.offlineSessionPings = [
      ...mutableCurrentOfflineFields.offlineSessionPings,
      ...appState.updateSessionState.offlineSessionPings,
    ];

    await extensionApi.setLocalStorage({ ...mutableCurrentOfflineFields });
    rootStore.dispatch(clearOfflineSessionPings());
  }
};
const OfflineSyncService = {
  init: async (): Promise<void> => {
    UtilsService.debugLog('Offline Sync Service Init');
    const extensionApi = ExtensionApiFactory();

    rootStore.subscribe(async () => {
      const appState = rootStore.getState();
      const offlineFields = await extensionApi.getLocalStorage<OfflineSyncFields>(OFFLINE_SYNC_FIELDS);

      UtilsService.debugLog('offlineFields', offlineFields, 'appState', appState);
      await updateOfflineSessionPings(offlineFields, appState);
    });
  },
  getOfflineSyncFields: async (): Promise<OfflineSyncFields> => {
    const extensionApi = ExtensionApiFactory();
    return extensionApi.getLocalStorage<OfflineSyncFields>(OFFLINE_SYNC_FIELDS);
  },
};

export default OfflineSyncService;
